'use strict';
const $policyProfiling = $(".profiling-policy");
const $policyProfilingPopup = $(".profiling-policy-popup");

module.exports = {
  init: function () {
  
    $policyProfiling.append($policyProfilingPopup);
    $policyProfiling.on("mouseleave", () => {
      $policyProfilingPopup.hide();
    });
    $policyProfiling.on("mouseenter", () => {
      $policyProfilingPopup.show();
    });
    $policyProfilingPopup.on("mouseenter", () => {
      $policyProfilingPopup.show();
    });
    $policyProfilingPopup.on("mouseleave", () => {
      $policyProfilingPopup.hide();
    });
  },

};
